import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MAIN_URL } from '../../api/url';

export const parseDateTime = (date) => (
  moment(date).format('DD.MM.YYYY HH.mm')
);

export const parseDateTimeDocuments = (date) => (
  moment(date).format('DD.MM.YYYY')
);

export const setToLocaleStorage = (key, value) => (
  localStorage.setItem(key, value)
);

export const getToLocaleStorage = (key) => (
  localStorage.getItem(key)
);

// Show search word and words before/after him;
export const showSearchString = (data, search) => {
  // Convert to a text without tags;
  const formatedText = data.text.replace(/<br ?\/?>/g, ' ').replace(/(<([^>]+)>)/gi, '');

  // Create an array of text;
  const textArray = formatedText.split(' ');

  // Get a matched word;
  const regex = new RegExp(search, 'ig');
  const matchedWord = textArray.filter((value) => value.match(regex));

  // Get an index of matched word
  const index = textArray.indexOf(matchedWord[0]);

  // Get 5 words before matched word;
  const wordsBefore = textArray.slice(index - 5, index).join(' ');

  // Get 5 words after matched word;
  const wordsAfter = textArray.slice(index + 1, index + 6).join(' ');

  // return a statement;
  if (index > 0) {
    return (
      <span>
        ...
        {' '}
        {wordsBefore}
        {' '}
        <strong>
          {matchedWord[0]}
        </strong>
        {' '}
        {wordsAfter}
        {' '}
        ...
      </span>
    );
  }
};

export const NewsImage = ({ news }) => {
  if (
    (news.assets.length === 0
    && news.news_flickr_image_relation.length === 0)
    || (news.assets === null
    && news.news_flickr_image_relation == null)
    || (typeof news.assets === 'undefined'
    && typeof news.news_flickr_image_relation === 'undefined')
  ) {
    return null;
  }

  if (news.assets.length !== 0) {
    for (let i = 0; i < news.assets.length; i += 1) {
      if (news.assets[i].main === '1'
      && news.assets[i].asset_type_id === 1) {
        return (
          <img loading="lazy" src={MAIN_URL + news.assets[i].new_path.replace('/', '')} alt="" />
        );
      }
    }
  }

  if ((news.assets.length === 0
  && news.news_flickr_image_relation.length !== 0)
  || (news.assets.length !== 0
  && news.assets[0].asset_type_id !== 1
  && news.news_flickr_image_relation.length !== 0)) {
    return <img loading="lazy" src={news.news_flickr_image_relation[0].src} alt="" />;
  }
};

export const showCountOfImages = (data) => (
  data.news_flickr_image_relation
  && data.news_flickr_image_relation.filter((t) => t.type === 'original').length > 0 ? (
    <span>{data.news_flickr_image_relation.filter((t) => t.type === 'original').length}</span>
    ) : 1
);

export const showVideoLength = (data) => (
  data.assets
  && data.assets.filter((t) => t.asset_type_id === 2).length > 0 ? (
    <span>{data.assets.filter((t) => t.asset_type_id === 2).length}</span>
    ) : null
);

export const ShowDocument = ({ event, searchText }) => {
  const navigate = useNavigate();

  return event.data.map((data) => (
    <div key={data.id} className="orders-item">
      <div className="orders-item">
        <a
          onClick={(e) => {
            e.preventDefault();
            navigate(
              `/event/documents/${data.news_type_relation[0].news_type.name}/${data.id}`,
            );
          }}
          href={`/event/documents/${data.news_type_relation[0].news_type.name}/${data.id}`}
          className="orders-link"
        >
          <span>{data.title}</span>
        </a>
        {
          searchText !== undefined
          && data.text
          && searchText.length > 1 ? (
            <div className="page-item__content">
              {showSearchString(data, searchText)}
            </div>
            ) : null
        }
        <div className="orders-box">
          <div className="saidbar-item__box">
            <div className="saidbar-item__date">
              <span>{parseDateTimeDocuments(data.publish_date)}</span>
              &nbsp;
              {data.number ? (
                <span>
                  №
                  {data.number}
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  ));
};

export const ShowEventInGroup = ({ event, groupType, searchText }) => {
  const navigate = useNavigate();
  const handleKeyPress = () => {};

  return event.data.map((data) => (
    (data.assets.length === 0
      && data.news_flickr_image_relation.length === 0) ? (
        <div key={data.id} className="orders-item">
          <div className="orders-item">
            <a
              onClick={(e) => {
                e.preventDefault();
                if (data.news_type_relation[0].news_type.name === 'government_assembly') {
                  navigate(
                    `/government/government_sessions/${data.id}`,
                  );
                } else {
                  navigate(
                    `/event/${groupType}/${data.id}`,
                  );
                }
              }}
              href={`/event/${groupType}/${data.id}`}
              className="orders-link"
            >
              <span>{data.title}</span>
            </a>
            {
              searchText !== undefined
              && data.text
              && searchText.length > 1 ? (
                <div className="page-item__content">
                  {showSearchString(data, searchText)}
                </div>
                ) : null
            }
            <div className="meetings-item__box">
              <div className="saidbar-item__box">
                <div className="saidbar-item__date">
                  <span>{parseDateTime(data.publish_date)}</span>
                  {data.city_relation.length > 0
                    ? data.city_relation.map((cityValue) => (
                      <span
                        key={cityValue.id}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/search_by_region/?q=${cityValue.city.name}`);
                        }}
                        style={{
                          cursor: 'pointer',
                          marginLeft: '4px',
                          marginBottom: '0px',
                          fontSize: '14px',
                        }}
                        className="main-tab__title"
                        onKeyDown={handleKeyPress}
                        role="button"
                        tabIndex="0"
                        aria-label="event"
                      >
                        {cityValue.city.name}
                      </span>
                    ))
                    : null}
                  {data.country_relation.length > 0
                    ? data.country_relation.map(
                      (countryValue) => (
                        <span
                          key={countryValue.id}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/search_by_country/?q=${countryValue.country.name}`);
                          }}
                          style={{
                            cursor: 'pointer',
                            marginLeft: '4px',
                            marginBottom: '0px',
                            fontSize: '14px',
                          }}
                          className="main-tab__title"
                          onKeyDown={handleKeyPress}
                          role="button"
                          tabIndex="0"
                          aria-label="event"
                        >
                          {' '}
                          {countryValue.country.name}
                        </span>
                      ),
                    )
                    : null}
                </div>
                <div className="saidbar-item__right">
                  {
                    (data.news_flickr_image_relation
                      && data.news_flickr_image_relation.filter((t) => t.type === 'original').length > 0)
                      || (data.assets
                      && data.assets.filter((t) => t.asset_type_id === 1).length > 0) ? (
                        <div className="saidbar-item__info">
                          <div className="saidbar-item__img">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              width="15"
                              height="12"
                              viewBox="0 0 15 12"
                            >
                              <path
                                className="st0"
                                d="M4.1,5.3c0.6,0,1.1-0.5,1.1-1.1S4.7,3,4.1,3S3,3.5,3,4.1S3.5,5.3,4.1,5.3z"
                                fill="#5F5F5F"
                              />
                              <path
                                className="st0"
                                d="M6.4,7.5L5.2,6L3,9h9L8.6,4.5L6.4,7.5z"
                                fill="#5F5F5F"
                              />
                              <path
                                className="st0"
                                d="M13.5,0h-12C0.7,0,0,0.7,0,1.5v9C0,11.3,0.7,12,1.5,12h12c0.8,0,
                                1.5-0.7,1.5-1.5v-9C15,0.7,14.3,0,13.5,0zM1.5,10.5v-9h12l0,9H1.5L1.5,10.5z"
                                fill="#5F5F5F"
                              />
                            </svg>
                          </div>
                          <div className="saidbar-item__count">
                            {showCountOfImages(data)}
                          </div>
                        </div>
                      ) : null
                  }
                  {
                  (data.assets
                    && data.assets.filter((t) => t.asset_type_id === 2).length > 0) ? (
                      <div className="saidbar-item__info">
                        <div className="saidbar-item__img">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                          >
                            <path
                              className="st0"
                              d="M7.5,0C3.4,0,0,3.4,0,7.5C0,11.6,3.4,15,7.5,15S15,11.6,15,7.5C15,3.4,11.6,0,7.5,0z M7.5,13.5c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6C13.5,10.8,10.8,13.5,7.5,13.5z"
                              fill="#5F5F5F"
                            />
                            <path
                              className="st0"
                              d="M5.2,11.3l6-3.8l-6-3.8V11.3z"
                              fill="#5F5F5F"
                            />
                          </svg>

                        </div>
                        <div className="saidbar-item__count">
                          {showVideoLength(data)}
                        </div>
                      </div>
                    ) : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div key={data.id} className="meetings-item">
          <div
            className="meetings-item__img"
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              e.preventDefault();
              if (data.news_type_relation[0].news_type.name === 'government_assembly') {
                navigate(
                  `/government/government_sessions/${data.id}`,
                );
              } else {
                navigate(
                  `/event/${groupType}/${data.id}`,
                );
              }
            }}
            onKeyDown={handleKeyPress}
            role="button"
            tabIndex="0"
          >
            <NewsImage news={data} />
          </div>
          <div className="meetings-item__content">
            {
              data.news_type_relation[0].news_type.name === 'government_assembly' ? (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(
                      `/government/government_sessions/${data.id}`,
                    );
                  }}
                  href={`/government/government_sessions/${data.id}`}
                  className="meetings-item__list"
                >
                  {data.title}
                </a>
              ) : (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(
                      `/event/${groupType}/${data.id}`,
                    );
                  }}
                  href={`/event/${groupType}/${data.id}`}
                  className="meetings-item__list"
                >
                  {data.title}
                </a>
              )
            }
            {
              searchText !== undefined
              && data.text
              && searchText.length > 1 ? (
                <div className="page-item__content">
                  {showSearchString(data, searchText)}
                </div>
                ) : null
            }
            <div className="meetings-item__box">
              <div className="saidbar-item__box">
                <div className="saidbar-item__date">
                  <span>{parseDateTime(data.publish_date)}</span>
                  {data.city_relation.length > 0
                    ? data.city_relation.map((cityValue) => (
                      <span
                        key={cityValue.id}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/search_by_region/?q=${cityValue.city.name}`);
                        }}
                        style={{
                          cursor: 'pointer',
                          marginLeft: '4px',
                          marginBottom: '0px',
                          fontSize: '14px',
                        }}
                        className="main-tab__title"
                        onKeyDown={handleKeyPress}
                        role="button"
                        tabIndex="0"
                        aria-label="event"
                      >
                        {cityValue.city.name}
                      </span>
                    ))
                    : null}
                  {data.country_relation.length > 0
                    ? data.country_relation.map((countryValue) => (
                      <span
                        key={countryValue.id}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/search_by_country/?q=${countryValue.country.name}`);
                        }}
                        onKeyDown={handleKeyPress(data)}
                        role="button"
                        tabIndex={0}
                        className="main-tab__title"
                        style={{ fontSize: '14px', marginBottom: '0em', marginLeft: '4px' }}
                      >
                        {' '}
                        {countryValue.country.name}
                      </span>
                    ))
                    : null}
                </div>
                <div className="saidbar-item__right">
                  {
                    (data.news_flickr_image_relation
                      && data.news_flickr_image_relation.filter((t) => t.type === 'original').length > 0)
                      || (data.assets
                      && data.assets.filter((t) => t.asset_type_id === 1).length > 0) ? (
                        <div className="saidbar-item__info">
                          <div className="saidbar-item__img">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              width="15"
                              height="12"
                              viewBox="0 0 15 12"
                            >
                              <path
                                className="st0"
                                d="M4.1,5.3c0.6,0,1.1-0.5,1.1-1.1S4.7,3,4.1,3S3,3.5,3,4.1S3.5,5.3,4.1,5.3z"
                                fill="#5F5F5F"
                              />
                              <path
                                className="st0"
                                d="M6.4,7.5L5.2,6L3,9h9L8.6,4.5L6.4,7.5z"
                                fill="#5F5F5F"
                              />
                              <path
                                className="st0"
                                d="M13.5,0h-12C0.7,0,0,0.7,0,1.5v9C0,11.3,0.7,12,1.5,12h12c0.8,0,
                                1.5-0.7,1.5-1.5v-9C15,0.7,14.3,0,13.5,0zM1.5,10.5v-9h12l0,9H1.5L1.5,10.5z"
                                fill="#5F5F5F"
                              />
                            </svg>
                          </div>
                          <div className="saidbar-item__count">
                            {showCountOfImages(data)}
                          </div>
                        </div>
                      ) : null
                  }
                  {
                  (data.assets
                    && data.assets.filter((t) => t.asset_type_id === 2).length > 0) ? (
                      <div className="saidbar-item__info">
                        <div className="saidbar-item__img">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                          >
                            <path
                              className="st0"
                              d="M7.5,0C3.4,0,0,3.4,0,7.5C0,11.6,3.4,15,7.5,15S15,11.6,15,7.5C15,3.4,11.6,0,7.5,0z M7.5,13.5c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6C13.5,10.8,10.8,13.5,7.5,13.5z"
                              fill="#5F5F5F"
                            />
                            <path
                              className="st0"
                              d="M5.2,11.3l6-3.8l-6-3.8V11.3z"
                              fill="#5F5F5F"
                            />
                          </svg>

                        </div>
                        <div className="saidbar-item__count">
                          {showVideoLength(data)}
                        </div>
                      </div>
                    ) : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      )
  ));
};

export const ShowEventOnMainPage = ({ event, type }) => {
  const navigate = useNavigate();

  const handleKeyPress = (data) => {
    navigate(`/search_by_region/?q=${data.city_relation[0].city.name}`);
  };

  return event.map((data) => (
    <div className="col-lg-6" key={data.id}>
      <div className="main-tab__item">
        <a
          onClick={(e) => {
            e.preventDefault();
            if (type === 'trips') {
              navigate(
                `/event/${data.news_type_relation[0].news_type.name
                  .replace('in_trips', 'domestic_trips')
                  .replace('out_trips', 'foreign_trips')}/${data.id}`,
              );
            } else {
              navigate(`/event/${type}/${data.id}`);
            }
          }}
          href={`/event/${type}/${data.id}`}
          className="main-tab__title"
        >
          {data.title || data.name}
        </a>
        <div className="saidbar-item__box">
          <div className="saidbar-item__date">
            <span>{parseDateTime(data.publish_date)}</span>
            {data.city_relation.length > 0
              ? data.city_relation.map((cityValue) => (
                <span
                  key={cityValue.id}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/search_by_region/${cityValue.city.name}`);
                  }}
                  style={{
                    cursor: 'pointer',
                    marginLeft: '4px',
                    marginBottom: '0px',
                    fontSize: '14px',
                  }}
                  className="main-tab__title"
                  onKeyDown={handleKeyPress}
                  role="button"
                  tabIndex="0"
                  aria-label="event"
                >
                  {' '}
                  {cityValue.city.name}
                </span>
              ))
              : null}
            {data.country_relation.length > 0
              ? data.country_relation.map((countryValue) => (
                <span key={countryValue.id}>
                  {' '}
                  {countryValue.country.name}
                </span>
              ))
              : null}
          </div>
          <div className="saidbar-item__right d-lg-none">
            <div className="saidbar-item__info">
              <div className="saidbar-item__img">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="12"
                  viewBox="0 0 15 12"
                >
                  <path
                    className="st0"
                    d="M4.1,5.3c0.6,0,1.1-0.5,1.1-1.1S4.7,3,4.1,3S3,3.5,3,4.1S3.5,5.3,4.1,5.3z"
                    fill="#5F5F5F"
                  />
                  <path
                    className="st0"
                    d="M6.4,7.5L5.2,6L3,9h9L8.6,4.5L6.4,7.5z"
                    fill="#5F5F5F"
                  />
                  <path
                    className="st0"
                    d="M13.5,0h-12C0.7,0,0,0.7,0,1.5v9C0,11.3,0.7,12,1.5,12h12c0.8,0,1.5-0.7,1.5-1.5v-9C15,0.7,14.3,0,13.5,0zM1.5,10.5v-9h12l0,9H1.5L1.5,10.5z"
                    fill="#5F5F5F"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));
};

export const ShowFilm = ({ data }) => {
  const navigate = useNavigate();
  const handleKeyPress = () => {};

  return data.data?.map((data) => (
    <div
      key={data.id}
      className="col-md-6 col-xl-3"
      onClick={(e) => {
        e.preventDefault();
        navigate(`/president/films/${data.type}/${data.id}`);
      }}
      onKeyDown={handleKeyPress}
      role="button"
      tabIndex="0"
      aria-label="film"
      style={{ cursor: 'pointer' }}
    >
      <a
        href={`/president/films/${data.type}/${data.id}`}
        onClick={(e) => {
          e.preventDefault();
          navigate(`/president/films/${data.type}/${data.id}`);
        }}
      >
        <div className="gallery-item">
          <div className="gallery-item__img">
            <img
              src={`${MAIN_URL}posters/${data.poster}`}
              alt=""
              style={{ width: '250px' }}
              loading="lazy"
            />
          </div>

          <div className="gallery-item__content">
            <a
              href={`/president/films/${data.type}/${data.id}`}
              className="gallery-item__link"
            >
              {data.name}
            </a>
          </div>
        </div>
      </a>
    </div>
  ));
};

export const ShowItemInSearch = ({ event, searchText }) => {
  const navigate = useNavigate();
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);

  const handleKeyDown = () => {};

  return event.data?.map((data) => {
    if ((data.news_type_relation[0]
    && data.news_type_relation[0].news_type.type === 'documents')
    || (data.news_type_relation[0]
    && data.news_type_relation[0].news_type.name === 'calls')
    || (data.news_type_relation[0]
    && data.news_type_relation[0].news_type.name === 'news')
    || (data.news_type_relation[0]
    && data.news_type_relation[0].news_type.name === 'telegrams')
    || data.assets.length < 1) {
      return (
        <div key={data.id} className="orders-item">
          <div className="orders-item">
            <a
              onClick={(e) => {
                e.preventDefault();
                if (data.news_type_relation[0].news_type.name === 'government_assembly') {
                  navigate(
                    `/government/government_sessions/${data.id}`,
                  );
                } else if (data.news_type_relation[0].news_type.type === 'news') {
                  navigate(
                    `/event/${data.news_type_relation[0].news_type.name
                      .replace('in_trips', 'domestic_trips')
                      .replace('out_trips', 'foreign_trips')}/${data.id}`,
                  );
                } else {
                  navigate(
                    `/event/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}/${data.id}`,
                  );
                }
              }}
              href=""
              className="orders-link"
            >
              <span>{data.title}</span>
            </a>
            {
              searchText !== undefined
              && data.text
              && searchText.length > 1 ? (
                <div className="page-item__content">
                  {showSearchString(data, searchText)}
                </div>
                ) : null
            }
            <div className="orders-box">
              <div className="saidbar-item__box">
                <div className="saidbar-item__date">
                  <span>{parseDateTime(data.publish_date)}</span>
                  {data.city_relation && data.city_relation.length > 0
                    ? data.city_relation.map((cityValue) => (
                      <span
                        key={cityValue.id}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/search_by_region/?q=${data.city_relation[0].city.name}`);
                        }}
                        onKeyDown={handleKeyDown(data)}
                        role="button"
                        tabIndex={0}
                        className="main-tab__title"
                        style={{ fontSize: '14px', marginBottom: '0em', marginLeft: '4px' }}
                      >
                        {cityValue.city.name}
                      </span>
                    ))
                    : null}
                  {data.country_relation && data.country_relation.length > 0
                    ? data.country_relation.map((countryValue) => (
                      <span
                        key={countryValue.id}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/search_by_country/?q=${data.country_relation[0].country.name}`);
                        }}
                        onKeyDown={handleKeyDown(data)}
                        role="button"
                        tabIndex={0}
                        className="main-tab__title"
                        style={{ fontSize: '14px', marginBottom: '0em', marginLeft: '4px' }}
                      >
                        {' '}
                        {countryValue.country.name}
                      </span>
                    ))
                    : null}
                  {data.number ? (
                    <span>
                      №
                      {data.number}
                    </span>
                  ) : null}
                  <br />
                  {data.news_type_relation[0] ? (
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        if (data.news_type_relation[0].news_type.type === 'documents') {
                          navigate(
                            `/event/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}`,
                          );
                        } else {
                          navigate(
                            `/event/${data.news_type_relation[0].news_type.name}`,
                          );
                        }
                      }}
                      href=""
                      className="main-tab__title"
                      style={{ fontSize: '14px', marginBottom: '0em' }}
                    >
                      {' '}
                      {dictionary[data.news_type_relation[0].news_type.name]}
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div key={data.id} className="meetings-item">
          <div
            className="meetings-item__img"
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              e.preventDefault();
              if (data.news_type_relation[0].news_type.type
                === 'internal_politics'
                || data.news_type_relation[0].news_type.type
                === 'international_structures'
                || data.news_type_relation[0].news_type.type
                === 'bilateral_relations') {
                navigate(
                  `/event_by_theme/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}/${data.id}`,
                );
              } else if (data.news_type_relation[0].news_type.name === 'government_assembly') {
                navigate(
                  `/government/government_sessions/${data.id}`,
                );
              } else {
                navigate(
                  `/event/${data.news_type_relation[0].news_type.name
                    .replace('in_trips', 'domestic_trips')
                    .replace('out_trips', 'foreign_trips')}/${data.id}`,
                );
              }
            }}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex="0"
          >
            <NewsImage news={data} />
          </div>
          <div className="meetings-item__content">
            <a
              onClick={(e) => {
                e.preventDefault();
                if (data.news_type_relation[0].news_type.type
                  === 'internal_politics'
                  || data.news_type_relation[0].news_type.type
                  === 'international_structures'
                  || data.news_type_relation[0].news_type.type
                  === 'bilateral_relations') {
                  navigate(
                    `/event_by_theme/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}/${data.id}`,
                  );
                } else if (data.news_type_relation[0].news_type.name === 'government_assembly') {
                  navigate(
                    `/government/government_sessions/${data.id}`,
                  );
                } else {
                  navigate(
                    `/event/${data.news_type_relation[0].news_type.name
                      .replace('in_trips', 'domestic_trips')
                      .replace('out_trips', 'foreign_trips')}/${data.id}`,
                  );
                }
              }}
              href=""
              className="meetings-item__list"
            >
              <span>{data.title}</span>
            </a>
            {
              searchText !== undefined
              && data.text
              && searchText.length > 1 ? (
                <div className="page-item__content">
                  {showSearchString(data, searchText)}
                </div>
                ) : null
            }
            <div className="meetings-item__box">
              <div className="saidbar-item__box">
                <div className="saidbar-item__date">
                  <span>{parseDateTime(data.publish_date)}</span>
                  {data.city_relation
                    ? data.city_relation.map((cityValue) => (
                      <span
                        key={cityValue.id}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/search_by_region/?q=${data.city_relation[0].city.name}`);
                        }}
                        onKeyDown={handleKeyDown(data)}
                        role="button"
                        tabIndex={0}
                        className="main-tab__title"
                        style={{ fontSize: '14px', marginBottom: '0em', marginLeft: '4px' }}
                      >
                        {' '}
                        {cityValue.city.name}
                      </span>
                    ))
                    : null}
                  {data.country_relation && data.country_relation.length > 0
                    ? data.country_relation.map((countryValue) => (
                      <span
                        key={countryValue.id}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/search_by_country/?q=${data.country_relation[0].country.name}`);
                        }}
                        onKeyDown={handleKeyDown(data)}
                        role="button"
                        tabIndex={0}
                        className="main-tab__title"
                        style={{ fontSize: '14px', marginBottom: '0em', marginLeft: '4px' }}
                      >
                        {' '}
                        {countryValue.country.name}
                      </span>
                    ))
                    : null}
                  {data.news_type_relation[0] ? (
                    <>
                      <br />
                      {data.news_type_relation[0].news_type.type === 'news' ? (
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            if (data.news_type_relation[0].news_type.name === 'government_assembly') {
                              navigate(
                                '/government/government_sessions',
                              );
                            } else {
                              navigate(`/event/${data.news_type_relation[0].news_type.name
                                .replace('in_trips', 'domestic_trips')
                                .replace('out_trips', 'foreign_trips')}`);
                            }
                          }}
                          href=""
                          className="main-tab__title"
                          style={{
                            fontSize: '14px',
                            marginBottom: '0em',
                          }}
                        >
                          {' '}
                          {
                            dictionary[
                              data.news_type_relation[0].news_type.name
                            ]
                          }
                        </a>
                      ) : null}
                      {data.news_type_relation[0].news_type.type
                      === 'internal_politics'
                      || data.news_type_relation[0].news_type.type
                      === 'international_structures'
                      || data.news_type_relation[0].news_type.type
                      === 'bilateral_relations' ? (
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(
                              `/event_by_theme/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name}`,
                            );
                          }}
                          href=""
                          className="main-tab__title"
                          style={{
                            fontSize: '14px',
                            marginBottom: '0em',
                          }}
                        >
                          {' '}
                          {
                            dictionary[
                              data.news_type_relation[0].news_type.name
                            ]
                          }
                          ,
                          {' '}
                          {
                            dictionary[
                              data.news_type_relation[0].news_type.type
                            ]
                          }
                        </a>
                        ) : null}
                    </>
                  ) : null}
                </div>
                <div className="saidbar-item__right">
                  {
                    (data.news_flickr_image_relation
                      && data.news_flickr_image_relation.filter((t) => t.type === 'original').length > 0)
                      || (data.assets
                      && data.assets.length > 0) ? (
                        <div className="saidbar-item__info">
                          <div className="saidbar-item__img">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              width="15"
                              height="12"
                              viewBox="0 0 15 12"
                            >
                              <path
                                className="st0"
                                d="M4.1,5.3c0.6,0,1.1-0.5,1.1-1.1S4.7,3,4.1,3S3,3.5,3,4.1S3.5,5.3,4.1,5.3z"
                                fill="#5F5F5F"
                              />
                              <path
                                className="st0"
                                d="M6.4,7.5L5.2,6L3,9h9L8.6,4.5L6.4,7.5z"
                                fill="#5F5F5F"
                              />
                              <path
                                className="st0"
                                d="M13.5,0h-12C0.7,0,0,0.7,0,1.5v9C0,11.3,0.7,12,1.5,12h12c0.8,0,
                                1.5-0.7,1.5-1.5v-9C15,0.7,14.3,0,13.5,0zM1.5,10.5v-9h12l0,9H1.5L1.5,10.5z"
                                fill="#5F5F5F"
                              />
                            </svg>
                          </div>
                          <div className="saidbar-item__count">
                            {showCountOfImages(data)}
                          </div>
                        </div>
                      ) : null
                  }
                  {
                  (data.assets
                    && data.assets.filter((t) => t.asset_type_id === 2).length > 0) ? (
                      <div className="saidbar-item__info">
                        <div className="saidbar-item__img">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                          >
                            <path
                              className="st0"
                              d="M7.5,0C3.4,0,0,3.4,0,7.5C0,11.6,3.4,15,7.5,15S15,11.6,15,7.5C15,3.4,11.6,0,7.5,0z M7.5,13.5c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6C13.5,10.8,10.8,13.5,7.5,13.5z"
                              fill="#5F5F5F"
                            />
                            <path
                              className="st0"
                              d="M5.2,11.3l6-3.8l-6-3.8V11.3z"
                              fill="#5F5F5F"
                            />
                          </svg>

                        </div>
                        <div className="saidbar-item__count">
                          {showVideoLength(data)}
                        </div>
                      </div>
                    ) : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  });
};

export const bookFiltersYear = [
  {
    label: 'year_descending',
    value: 'year_desc',
  },
  {
    label: 'year_ascending',
    value: 'year_asc',
  },
];

export const bookFiltersAlph = [
  {
    label: 'alph_descending',
    value: 'alph_desc',
  },
  {
    label: 'alph_ascending',
    value: 'alph_asc',
  },
];
